/* @ngInject */
export default function ($state, AuthService, LayoutService) {
	LayoutService.setTitle('Welcome to All About Caring');
	LayoutService.getPageHeader()
	             .setDescription('Your dashboard will load shortly.');

	$state.go(AuthService.getType() + '.dashboard');
};


// WEBPACK FOOTER //
// ./src/js/endpoints/splash/home/controller.js